
import { defineComponent } from "vue";

import CardKnowledgeHub from "~/vue/molecules/cards/CardKnowledgeHub.vue";
import ConsentHidden from "~/vue/organisms/consents/ConsentHidden.vue";
import ViewBlog from "~/vue/organisms/views/ViewBlog.vue";
import ViewCaseStudies from "~/vue/organisms/views/ViewCaseStudies.vue";
import ViewDossiers from "~/vue/organisms/views/ViewDossiers.vue";
import ViewKnowledgeHub from "~/vue/organisms/views/ViewKnowledgeHub.vue";
import ViewNews from "~/vue/organisms/views/ViewNews.vue";
import ViewPress from "~/vue/organisms/views/ViewPress.vue";
import ViewTransactions from "~/vue/organisms/views/ViewTransactions.vue";
import ViewWhitepapers from "~/vue/organisms/views/ViewWhitepapers.vue";
import ViewEvents from "~/vue/organisms/views/ViewEvents.vue";

export default defineComponent({
	components: {
		"card--knowledge-hub": CardKnowledgeHub,
		"consent--hidden": ConsentHidden,
		"view--blog": ViewBlog,
		"view--case-studies": ViewCaseStudies,
		"view--dossiers": ViewDossiers,
		"view--knowledge-hub": ViewKnowledgeHub,
		"view--news": ViewNews,
		"view--press": ViewPress,
		"view--transactions": ViewTransactions,
		"view--whitepapers": ViewWhitepapers,
		"view--event": ViewEvents,
	},
});
